import fleetApi from '../../services/api.service';
import { buildUrlWithParams } from '../../utils/url.utils';

/**
 * Version à jour d'un envoi AS400, indépendamment des filtres de la liste
 * (recherche sur son n° de tournée, puis sélection par identifiant).
 * Retourne null si l'envoi n'est pas retrouvé.
 */
export default async function getTourLog(log) {
  const response = await fleetApi.get(
    buildUrlWithParams('/tours/tours-logs', {
      query: log.tour_key,
      limit: 100,
      offset: 0,
    })
  );
  return response.data?.items?.find((item) => item.id === log.id) || null;
}
